/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styles from './styles.scss';

const kFreqRange = {
  CN470: {
    min: 470,
    max: 490,
  },
  US902: {
    min: 902,
    max: 915,
  },
  AU915: {
    min: 915,
    max: 928,
  },
  EU863: {
    min: 863,
    max: 870,
  },
  CN470PREQUEL: {
    min: 470,
    max: 510,
  },
  EU868SEMTECH: {
    min: 863,
    max: 870,
  },
  AS923: {
    min: 915,
    max: 928,
  },
};


const propTypes = {
  plan: React.PropTypes.object.isRequired,
};

class FreqSpectrum extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  render() {
    const { plan = {} } = this.state;
    const { band = '', channels = [] } = plan;

    if (band === '') {
      return null;
    }

    const freqRange = kFreqRange[band];
    if (_.isNil(freqRange)) return null;
    const bandWidth = freqRange.max - freqRange.min;

    return (
      <div className={styles.spectrum}>
        {channels.map((ch) => {
          const tooltip = (
            <Tooltip id={`${plan.id}-${ch.id}`}>
              <div className={styles.tooltip}>
                <div>
                  <span className={styles.label}>ID</span>
                  <span className={styles.value}>{ch.id}</span>
                </div>
                <div>
                  <span className={styles.label}>Frequency</span>
                  <span className={styles.value}>{ch.freq / 1000000}MHz</span>
                </div>
                <div>
                  <span className={styles.label}>MinDR</span>
                  <span className={styles.value}>{ch.mindr}</span>
                </div>
                <div>
                  <span className={styles.label}>MaxDR</span>
                  <span className={styles.value}>{ch.maxdr}</span>
                </div>
              </div>
            </Tooltip>
          );
          return (
            <OverlayTrigger key={ch.id} placement="top" overlay={tooltip}>
              <div
                className={styles.freq}
                style={{
                  width: `${(0.125 / bandWidth) * 100}%`,
                  left: `${(((ch.freq / 1000000) - freqRange.min) / bandWidth) * 100}%`,
                }}
              />
            </OverlayTrigger>

          );
        })}
      </div>
    );
  }
}

FreqSpectrum.propTypes = propTypes;

export default FreqSpectrum;




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/FreqSpectrum/index.jsx